import React, {Component} from 'react';

class Loadersmall extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // menu:[],
        }
    }

    render() {
        return (
            <div className="ps-inline-placeholder" aria-label="Loading content">
                <span></span>
                <span></span>
                <span></span>
            </div>
        );
    }
}

export default Loadersmall;
